module.exports = __webpack_public_path__ + "img/quick-burger.c04bae4d.png";